import React, { useState, useMemo } from 'react';
import { Helmet } from 'react-helmet';
import Header from '../../components/ui/Header';
import Footer from '../../components/ui/Footer';
import Icon from '../../components/AppIcon';
import Button from '../../components/ui/Button';
import PartCard from './components/PartCard';
import CategoryFilter from './components/CategoryFilter';
import CompatibilityChecker from './components/CompatibilityChecker';
import PartDetailModal from './components/PartDetailModal';
import SearchBar from './components/SearchBar';
import FeaturedParts from './components/FeaturedParts';
import Pagination from '../../components/ui/Pagination';


const ITEMS_PER_PAGE = 8;
const PartsAndAccessories = () => {
  const [searchQuery, setSearchQuery] = useState('');
  const [activeCategory, setActiveCategory] = useState('all');
  const [selectedPart, setSelectedPart] = useState(null);
  const [compatibilityFilter, setCompatibilityFilter] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const catalogRef = React.useRef(null);




  const categories = [
  { id: 'all', name: 'Semua Kategori', icon: 'Grid3x3', count: 48 },
  { id: 'engine', name: 'Mesin & Transmisi', icon: 'Cog', count: 12 },
  { id: 'body', name: 'Body & Rangka', icon: 'Box', count: 8 },
  { id: 'electrical', name: 'Kelistrikan', icon: 'Zap', count: 10 },
  { id: 'brake', name: 'Rem & Suspensi', icon: 'Disc', count: 6 },
  { id: 'accessories', name: 'Aksesoris', icon: 'Sparkles', count: 12 }];


  const motorcycles = [
  // =====================
  // MATIC
  // =====================
  {
    id: 'beat',
    name: 'Beat',
    years: [2024, 2023, 2022, 2021, 2020]
  },
  {
    id: 'genio',
    name: 'Genio',
    years: [2024, 2023, 2022, 2021, 2020]
  },
  {
    id: 'scoopy',
    name: 'Scoopy',
    years: [2024, 2023, 2022, 2021, 2020]
  },
  {
    id: 'vario-125',
    name: 'Vario 125',
    years: [2024, 2023, 2022, 2021]
  },
  {
    id: 'vario-160',
    name: 'Vario 160',
    years: [2024, 2023, 2022, 2021]
  },
  {
    id: 'stylo-160',
    name: 'Stylo 160',
    years: [2024, 2023]
  },
  {
    id: 'pcx-160',
    name: 'PCX 160',
    years: [2024, 2023, 2022]
  },
  {
    id: 'adv-160',
    name: 'ADV 160',
    years: [2024, 2023, 2022]
  },

  // =====================
  // BEBEK
  // =====================
  {
    id: 'revo',
    name: 'Revo',
    years: [2024, 2023, 2022, 2021]
  },
  {
    id: 'supra-x',
    name: 'Supra X',
    years: [2024, 2023, 2022, 2021]
  },
  {
    id: 'supra-gtr-150',
    name: 'Supra GTR 150',
    years: [2024, 2023, 2022]
  },

  // =====================
  // EV
  // =====================
  {
    id: 'em1-e',
    name: 'EM1 e:',
    years: [2024, 2023]
  },
  {
    id: 'icon-e',
    name: 'ICON e:',
    years: [2024, 2023]
  },
  {
    id: 'cuv-e',
    name: 'CUV e:',
    years: [2024, 2023]
  },

  // =====================
  // SPORT
  // =====================
  {
    id: 'cb150-verza',
    name: 'CB150 Verza',
    years: [2024, 2023, 2022]
  },
  {
    id: 'sonic-150r',
    name: 'Sonic 150R',
    years: [2024, 2023, 2022]
  },
  {
    id: 'cb150r-streetfire',
    name: 'CB150R StreetFire',
    years: [2024, 2023, 2022]
  },
  {
    id: 'cb150x',
    name: 'CB150X',
    years: [2024, 2023, 2022]
  },
  {
    id: 'cbr150r',
    name: 'CBR150R',
    years: [2024, 2023, 2022, 2021]
  },
  {
    id: 'crf150l',
    name: 'CRF150L',
    years: [2024, 2023, 2022]
  },
  {
    id: 'cbr250rr',
    name: 'CBR250RR',
    years: [2024, 2023]
  },
  {
    id: 'monkey',
    name: 'Monkey',
    years: [2024, 2023]
  },
  {
    id: 'crf250-rally',
    name: 'CRF250 Rally',
    years: [2024, 2023]
  }
];


  const parts = [
  {
    id: 1,
    name: "Kampas Rem Depan Original",
    category: "Rem & Suspensi",
    categoryId: "brake",
    description: "Kampas rem depan original Honda dengan daya cengkeram optimal dan ketahanan tinggi untuk keamanan berkendara maksimal",
    partCode: "06455-K25-901",
    price: 125000,
    stock: 15,
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_1c1e145ec-1764654713287.png",
    imageAlt: "Close-up view of genuine Honda front brake pads showing red friction material and metal backing plate with Honda branding",
    isGenuine: true,
    isNew: false,
    warranty: "6 Bulan",
    compatibleModels: ["Beat", "Vario 160", "Scoopy"],
    specifications: [
    { label: "Material", value: "Semi-Metallic" },
    { label: "Ketebalan", value: "4.5mm" },
    { label: "Berat", value: "120g" }],

    additionalImages: [
    { url: "https://img.rocket.new/generatedImages/rocket_gen_img_108306c29-1764661222349.png", alt: "Front view of brake pad showing friction surface" },
    { url: "https://img.rocket.new/generatedImages/rocket_gen_img_16a41b94d-1766488080504.png", alt: "Side profile of brake pad showing thickness" }]

  },
  {
    id: 2,
    name: "Filter Oli Original Honda",
    category: "Mesin & Transmisi",
    categoryId: "engine",
    description: "Filter oli original Honda dengan teknologi penyaringan terbaik untuk menjaga kebersihan oli dan performa mesin optimal",
    partCode: "15410-KZR-601",
    price: 45000,
    stock: 25,
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_191bc4162-1764654712069.png",
    imageAlt: "Cylindrical Honda genuine oil filter with white body and red Honda logo showing threaded connection port",
    isGenuine: true,
    isNew: false,
    warranty: "3 Bulan",
    compatibleModels: ["Beat", "Vario 160", "Scoopy", "PCX 160"],
    specifications: [
    { label: "Tipe", value: "Cartridge" },
    { label: "Diameter", value: "65mm" },
    { label: "Tinggi", value: "85mm" }]

  },
  {
    id: 3,
    name: "Busi Iridium NGK",
    category: "Kelistrikan",
    categoryId: "electrical",
    description: "Busi iridium NGK dengan elektroda iridium untuk pembakaran sempurna, akselerasi responsif, dan efisiensi bahan bakar maksimal",
    partCode: "CPR9EAIX-9",
    price: 85000,
    stock: 20,
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_1827d6661-1764654712461.png",
    imageAlt: "NGK iridium spark plug with silver body showing threaded base and iridium electrode tip with insulator",
    isGenuine: true,
    isNew: true,
    warranty: "12 Bulan",
    compatibleModels: ["Vario 160", "PCX 160", "CBR150R"],
    specifications: [
    { label: "Gap", value: "0.8mm" },
    { label: "Thread", value: "M10x1.0" },
    { label: "Reach", value: "19mm" }]

  },
  {
    id: 4,
    name: "Rantai Drive Chain RK",
    category: "Mesin & Transmisi",
    categoryId: "engine",
    description: "Rantai drive chain RK dengan teknologi O-ring untuk ketahanan maksimal dan perpindahan tenaga yang efisien",
    partCode: "RK428HSB-120L",
    price: 285000,
    stock: 8,
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_18c66ea16-1765092388447.png",
    imageAlt: "Coiled motorcycle drive chain showing metallic links with O-ring seals and connecting master link",
    isGenuine: false,
    isNew: false,
    warranty: "6 Bulan",
    compatibleModels: ["Beat", "Vario 160", "Scoopy"],
    specifications: [
    { label: "Pitch", value: "428" },
    { label: "Links", value: "120L" },
    { label: "Type", value: "O-Ring" }]

  },
  {
    id: 5,
    name: "Spion Lipat Original",
    category: "Body & Rangka",
    categoryId: "body",
    description: "Spion lipat original Honda dengan desain aerodinamis dan kaca anti-silau untuk visibilitas optimal dan keamanan berkendara",
    partCode: "88220-K25-900",
    price: 165000,
    stock: 12,
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_15c2a1d47-1764746309359.png",
    imageAlt: "Black Honda foldable side mirror with aerodynamic housing and anti-glare glass showing mounting bracket",
    isGenuine: true,
    isNew: false,
    warranty: "12 Bulan",
    compatibleModels: ["Beat", "Vario 160", "Scoopy", "PCX 160"],
    specifications: [
    { label: "Warna", value: "Hitam" },
    { label: "Tipe", value: "Lipat Manual" },
    { label: "Kaca", value: "Anti-Silau" }]

  },
  {
    id: 6,
    name: "Lampu LED Headlight",
    category: "Kelistrikan",
    categoryId: "electrical",
    description: "Lampu LED headlight dengan intensitas cahaya tinggi 6000K untuk visibilitas maksimal dan konsumsi daya rendah",
    partCode: "LED-H4-6000K",
    price: 325000,
    stock: 10,
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_14a31d3d0-1765328522066.png",
    imageAlt: "Modern LED motorcycle headlight bulb with cooling fan and H4 connector showing bright white light output",
    isGenuine: false,
    isNew: true,
    warranty: "12 Bulan",
    compatibleModels: ["Vario 160", "PCX 160", "CBR150R"],
    specifications: [
    { label: "Watt", value: "20W" },
    { label: "Lumens", value: "2400lm" },
    { label: "Color Temp", value: "6000K" }]

  },
  {
    id: 7,
    name: "Shock Breaker Belakang KYB",
    category: "Rem & Suspensi",
    categoryId: "brake",
    description: "Shock breaker belakang KYB dengan teknologi gas-charged untuk kenyamanan berkendara optimal dan handling yang stabil",
    partCode: "KYB-SB-125",
    price: 485000,
    stock: 6,
    image: "https://images.unsplash.com/photo-1678383409086-463b09ac5f66",
    imageAlt: "Pair of KYB rear shock absorbers with black body and red spring showing mounting brackets and adjustment knobs",
    isGenuine: false,
    isNew: false,
    warranty: "12 Bulan",
    compatibleModels: ["Beat", "Vario 160", "Scoopy"],
    specifications: [
    { label: "Panjang", value: "320mm" },
    { label: "Type", value: "Gas-Charged" },
    { label: "Adjustable", value: "5 Level" }]

  },
  {
    id: 8,
    name: "Knalpot Racing Akrapovic",
    category: "Mesin & Transmisi",
    categoryId: "engine",
    description: "Knalpot racing Akrapovic dengan material titanium untuk performa maksimal, suara sporty, dan bobot ringan",
    partCode: "AKR-PCX-160",
    price: 2850000,
    stock: 3,
    image: "https://images.unsplash.com/photo-1662721939623-780e3de5c15d",
    imageAlt: "Akrapovic titanium racing exhaust system with carbon fiber heat shield and polished end cap showing mounting hardware",
    isGenuine: false,
    isNew: true,
    warranty: "24 Bulan",
    compatibleModels: ["PCX 160"],
    specifications: [
    { label: "Material", value: "Titanium" },
    { label: "Berat", value: "2.8kg" },
    { label: "Power Gain", value: "+2.5HP" }]

  },
  {
    id: 9,
    name: "Windshield Smoke Original",
    category: "Aksesoris",
    categoryId: "accessories",
    description: "Windshield smoke original Honda dengan material acrylic berkualitas tinggi untuk perlindungan dari angin dan tampilan sporty",
    partCode: "08R70-K25-800",
    price: 425000,
    stock: 7,
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_13551d7d9-1764708894782.png",
    imageAlt: "Smoke-tinted motorcycle windshield made of acrylic showing curved aerodynamic design with mounting brackets",
    isGenuine: true,
    isNew: false,
    warranty: "6 Bulan",
    compatibleModels: ["PCX 160", "Vario 160"],
    specifications: [
    { label: "Material", value: "Acrylic" },
    { label: "Tinggi", value: "45cm" },
    { label: "Warna", value: "Smoke" }]

  },
  {
    id: 10,
    name: "Grip Handle Racing",
    category: "Aksesoris",
    categoryId: "accessories",
    description: "Grip handle racing dengan material rubber anti-slip untuk kenyamanan dan kontrol maksimal saat berkendara",
    partCode: "GRP-RACE-BK",
    price: 95000,
    stock: 18,
    image: "https://images.unsplash.com/photo-1564030390679-eb13a6944828",
    imageAlt: "Pair of black racing handlebar grips with textured anti-slip rubber surface and red accent rings",
    isGenuine: false,
    isNew: false,
    warranty: "3 Bulan",
    compatibleModels: ["Beat", "Vario 160", "Scoopy", "PCX 160", "CBR150R"],
    specifications: [
    { label: "Material", value: "Rubber" },
    { label: "Panjang", value: "12cm" },
    { label: "Diameter", value: "22mm" }]

  },
  {
    id: 11,
    name: "Cover Jok Anti-Air Premium",
    category: "Aksesoris",
    categoryId: "accessories",
    description: "Cover jok anti-air premium dengan material waterproof dan breathable untuk melindungi jok dari hujan dan panas",
    partCode: "CVR-SEAT-WP",
    price: 145000,
    stock: 14,
    image: "https://images.unsplash.com/photo-1679842708430-8ded0675f22f",
    imageAlt: "Black waterproof motorcycle seat cover with elastic edges and breathable mesh panels showing Honda logo",
    isGenuine: false,
    isNew: true,
    warranty: "6 Bulan",
    compatibleModels: ["Beat", "Vario 160", "Scoopy", "PCX 160"],
    specifications: [
    { label: "Material", value: "Polyester" },
    { label: "Waterproof", value: "Yes" },
    { label: "UV Protection", value: "Yes" }]

  },
  {
    id: 12,
    name: "Bracket Box Original Honda",
    category: "Aksesoris",
    categoryId: "accessories",
    description: "Bracket box original Honda dengan konstruksi kokoh untuk pemasangan top box dengan kapasitas beban hingga 10kg",
    partCode: "08L70-K25-800",
    price: 385000,
    stock: 9,
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_12895c3d0-1767618119681.png",
    imageAlt: "Black metal Honda top box bracket showing sturdy construction with mounting points and reinforcement bars",
    isGenuine: true,
    isNew: false,
    warranty: "12 Bulan",
    compatibleModels: ["Beat", "Vario 160", "Scoopy", "PCX 160"],
    specifications: [
    { label: "Material", value: "Steel" },
    { label: "Max Load", value: "10kg" },
    { label: "Finish", value: "Powder Coat" }]

  }];

  React.useEffect(() => {
      setCurrentPage(1);
    }, [searchQuery, activeCategory, compatibilityFilter]);


  const filteredParts = useMemo(() => {
    let result = parts;

    if (activeCategory !== 'all') {
      result = result?.filter((part) => part?.categoryId === activeCategory);
    }

    if (searchQuery) {
      const query = searchQuery?.toLowerCase();
      result = result?.filter((part) =>
      part?.name?.toLowerCase()?.includes(query) ||
      part?.partCode?.toLowerCase()?.includes(query) ||
      part?.category?.toLowerCase()?.includes(query) ||
      part?.description?.toLowerCase()?.includes(query)
      );
    }

    if (compatibilityFilter) {
      const modelName = motorcycles?.find((m) => m?.id === compatibilityFilter?.model)?.name;
      result = result?.filter((part) =>
      part?.compatibleModels?.some((model) =>
      model?.toLowerCase()?.includes(modelName?.toLowerCase()?.split(' ')?.[1] || modelName?.toLowerCase())
      )
      );
    }

    return result;
  }, [activeCategory, searchQuery, compatibilityFilter, parts, motorcycles]);

  const totalPages = Math.ceil(filteredParts.length / ITEMS_PER_PAGE);

  const paginatedParts = useMemo(() => {
    const start = (currentPage - 1) * ITEMS_PER_PAGE;
    return filteredParts.slice(start, start + ITEMS_PER_PAGE);
  }, [filteredParts, currentPage]);


  const handleConsult = (part) => {
    const message = `Halo, saya tertarik dengan ${part?.name} (${part?.partCode}). Apakah masih tersedia?`;
    window.open(`https://wa.me/6288293642972?text=${encodeURIComponent(message)}`, '_blank');
  };

  const handleCompatibilityCheck = (filter) => {
    setCompatibilityFilter(filter);
    window.scrollTo({ top: 400, behavior: 'smooth' });
  };

  return (
    <>
      <Helmet>
        <title>Suku Cadang & Aksesoris - Honda Pamulang</title>
        <meta name="description" content="Katalog lengkap suku cadang dan aksesoris original Honda. Cek kompatibilitas part dengan motor Anda dan dapatkan garansi resmi." />
      </Helmet>
      <Header />
      <main className="min-h-screen bg-background" >
        <section className="bg-gradient-to-br from-primary to-accent py-12 md:py-16 lg:py-20" >
          <div className="container mx-auto px-4" data-aos="fade-up" data-aos-delay="150">
            <div className="max-w-4xl mx-auto text-center">
              <div className="inline-flex items-center space-x-2 bg-primary-foreground/20 backdrop-blur-sm px-4 py-2 rounded-full mb-6">
                <Icon name="Package" size={20} color="white" />
                <span className="text-sm font-heading font-semibold text-primary-foreground">
                  Genuine Honda Parts
                </span>
              </div>
              
              <h1 className="text-3xl md:text-4xl lg:text-5xl font-heading font-bold text-primary-foreground mb-4">
                Suku Cadang & Aksesoris
              </h1>
              
              <p className="text-base md:text-lg text-primary-foreground/90 mb-8 max-w-2xl mx-auto">
                Temukan suku cadang original dan aksesoris berkualitas untuk motor Honda Anda. 
                Garansi resmi dan kompatibilitas terjamin.
              </p>

              <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
                <Button
                  variant="secondary"
                  size="lg"
                  iconName="MessageCircle"
                  iconPosition="left"
                  onClick={() => window.open('https://wa.me/6288293642972', '_blank')}>

                  Konsultasi Part
                </Button>
                <Button
                  variant="outline"
                  size="lg"
                  iconName="Calendar"
                  iconPosition="left"
                  onClick={() => window.location.href = '/service-booking'}
                  className="bg-primary-foreground/10 backdrop-blur-sm text-primary-foreground border-primary-foreground/30 hover:bg-primary-foreground/20">

                  Booking Service
                </Button>
              </div>
            </div>
          </div>
        </section>  

        <section ref={catalogRef} className="py-8 md:py-12 lg:py-16">
          <div className="container mx-auto px-4">
            <div className="grid grid-cols-1 lg:grid-cols-3 gap-6 lg:gap-8">
              <div className="lg:col-span-1 space-y-6">
                <CompatibilityChecker
                  motorcycles={motorcycles}
                  onCheck={handleCompatibilityCheck} />


                <CategoryFilter
                  categories={categories}
                  activeCategory={activeCategory}
                  onCategoryChange={setActiveCategory} />


                <div className="bg-card rounded-lg p-4 md:p-6 shadow-card-hover">
                  <h3 className="text-lg font-heading font-bold text-foreground mb-4 flex items-center space-x-2">
                    <Icon name="Info" size={20} color="var(--color-primary)" />
                    <span>Informasi Penting</span>
                  </h3>
                  <div className="space-y-3 text-sm text-muted-foreground">
                    <div className="flex items-start space-x-2">
                      <Icon name="Shield" size={16} color="var(--color-success)" className="mt-0.5 flex-shrink-0" />
                      <p>Semua part genuine Honda bergaransi resmi</p>
                    </div>
                    <div className="flex items-start space-x-2">
                      <Icon name="Truck" size={16} color="var(--color-success)" className="mt-0.5 flex-shrink-0" />
                      <p>Pengiriman tersedia untuk area Tangerang Selatan</p>
                    </div>
                    <div className="flex items-start space-x-2">
                      <Icon name="CheckCircle" size={16} color="var(--color-success)" className="mt-0.5 flex-shrink-0" />
                      <p>Pemasangan gratis untuk pembelian di dealer</p>
                    </div>
                  </div>
                </div>
              </div>

              <div className="lg:col-span-2 space-y-6">
                <div className="bg-card rounded-lg p-4 md:p-6 shadow-card-hover">
                  <div className="flex flex-col md:flex-row md:items-center justify-between gap-4 mb-6">
                    <div>
                      <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground mb-2">
                        Katalog Produk
                      </h2>
                      <p className="text-sm text-muted-foreground">
                        Menampilkan {filteredParts?.length} dari {parts?.length} produk
                        {compatibilityFilter &&
                        <span className="ml-2 text-primary font-medium">
                            (Kompatibel dengan {motorcycles?.find((m) => m?.id === compatibilityFilter?.model)?.name} {compatibilityFilter?.year})
                          </span>
                        }
                      </p>
                    </div>
                    {compatibilityFilter &&
                    <Button
                      variant="outline"
                      size="default"
                      iconName="X"
                      iconPosition="left"
                      onClick={() => setCompatibilityFilter(null)}>

                        Reset Filter
                      </Button>
                    }
                  </div>

                  <SearchBar
                    value={searchQuery}
                    onChange={setSearchQuery}
                    onClear={() => setSearchQuery('')} />

                </div>

                {!searchQuery && !compatibilityFilter && activeCategory === 'all' &&
                <FeaturedParts
                  parts={parts?.filter((p) => p?.isNew || p?.id <= 3)}
                  onViewAll={() => setActiveCategory('all')} />

                }

                {filteredParts?.length > 0 ?
                <>
                  <div className="grid grid-cols-2 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
                    {paginatedParts?.map((part) =>
                      <PartCard
                        key={part?.id}
                        part={part}
                        onConsult={handleConsult}
                        onViewDetails={setSelectedPart}
                      />
                    )}
                  </div>

                  {/* PAGINATION — BARU */}
                  {totalPages > 1 && (
                    <div className="pt-6">
                      <Pagination
                        currentPage={currentPage}
                        totalPages={totalPages}
                        onPageChange={(page) => {
                          setCurrentPage(page);
                          setTimeout(() => {
                            catalogRef.current?.scrollIntoView({
                              behavior: 'smooth',
                              block: 'start'
                            });
                          }, 50);
                        }}
                      />
                    </div>
                  )}
                </> :
                
                <div className="bg-card rounded-lg p-8 md:p-12 text-center shadow-card-hover">
                    <div className="w-20 h-20 bg-muted rounded-full flex items-center justify-center mx-auto mb-4">
                      <Icon name="Search" size={40} color="var(--color-muted-foreground)" />
                    </div>
                    <h3 className="text-xl font-heading font-bold text-foreground mb-2">
                      Tidak Ada Hasil
                    </h3>
                    <p className="text-muted-foreground mb-6">
                      Maaf, tidak ada produk yang sesuai dengan pencarian Anda.
                      Coba ubah kata kunci atau filter yang digunakan.
                    </p>
                    <Button
                    variant="outline"
                    size="default"
                    iconName="RotateCcw"
                    iconPosition="left"
                    onClick={() => {
                      setSearchQuery('');
                      setActiveCategory('all');
                      setCompatibilityFilter(null);
                    }}>

                      Reset Semua Filter
                    </Button>
                  </div>
                }
              </div>
            </div>
          </div>
        </section>

        <section className="py-8 md:py-12 lg:py-16 bg-muted">
          <div className="container mx-auto px-4">
            <div className="max-w-4xl mx-auto">
              <div className="text-center mb-8 md:mb-12">
                <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground mb-4">
                  Mengapa Pilih Part Original Honda?
                </h2>
                <p className="text-muted-foreground">
                  Investasi terbaik untuk performa dan keamanan motor Anda
                </p>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                <div className="bg-card rounded-lg p-6 text-center shadow-card-hover">
                  <div className="w-16 h-16 bg-primary/10 rounded-full flex items-center justify-center mx-auto mb-4">
                    <Icon name="Shield" size={32} color="var(--color-primary)" />
                  </div>
                  <h3 className="text-lg font-heading font-bold text-foreground mb-2">
                    Garansi Resmi
                  </h3>
                  <p className="text-sm text-muted-foreground">
                    Setiap part genuine Honda dilengkapi garansi resmi untuk ketenangan Anda
                  </p>
                </div>

                <div className="bg-card rounded-lg p-6 text-center shadow-card-hover">
                  <div className="w-16 h-16 bg-primary/10 rounded-full flex items-center justify-center mx-auto mb-4">
                    <Icon name="CheckCircle" size={32} color="var(--color-primary)" />
                  </div>
                  <h3 className="text-lg font-heading font-bold text-foreground mb-2">
                    Kualitas Terjamin
                  </h3>
                  <p className="text-sm text-muted-foreground">
                    Diproduksi dengan standar Honda untuk performa dan ketahanan optimal
                  </p>
                </div>

                <div className="bg-card rounded-lg p-6 text-center shadow-card-hover">
                  <div className="w-16 h-16 bg-primary/10 rounded-full flex items-center justify-center mx-auto mb-4">
                    <Icon name="Wrench" size={32} color="var(--color-primary)" />
                  </div>
                  <h3 className="text-lg font-heading font-bold text-foreground mb-2">
                    Pemasangan Gratis
                  </h3>
                  <p className="text-sm text-muted-foreground">
                    Teknisi berpengalaman siap memasang part dengan presisi tinggi
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="py-8 md:py-12 lg:py-16">
          <div className="container mx-auto px-4">
            <div className="bg-gradient-to-br from-primary to-accent rounded-lg p-6 md:p-8 lg:p-12 text-center">
              <div className="max-w-3xl mx-auto">
                <h2 className="text-2xl md:text-3xl font-heading font-bold text-primary-foreground mb-4">
                  Butuh Bantuan Memilih Part yang Tepat?
                </h2>
                <p className="text-base md:text-lg text-primary-foreground/90 mb-8">
                  Tim ahli kami siap membantu Anda menemukan suku cadang yang sesuai dengan kebutuhan motor Honda Anda
                </p>
                <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
                  <Button
                    variant="secondary"
                    size="lg"
                    iconName="MessageCircle"
                    iconPosition="left"
                    onClick={() => window.open('https://wa.me/6288293642972', '_blank')}>

                    Chat WhatsApp
                  </Button>
                  <Button
                    variant="outline"
                    size="lg"
                    iconName="Phone"
                    iconPosition="left"
                    onClick={() => window.location.href = 'tel:+6288293642972'}
                    className="bg-primary-foreground/10 backdrop-blur-sm text-primary-foreground border-primary-foreground/30 hover:bg-primary-foreground/20">

                    Hubungi Kami
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
      {selectedPart &&
      <PartDetailModal
        part={selectedPart}
        onClose={() => setSelectedPart(null)}
        onConsult={handleConsult} />

      }
    </>);

};

export default PartsAndAccessories;